import * as React from 'react';
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Button from './Shared/Button'; // Ensure path is correct
import { useNavigate } from 'react-router-dom';
// import Logo from '../assets/images/logo-placeholder.png'; // Add your logo image

// Placeholder Icons (replace with actual icons e.g., from react-icons)
const MenuIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" /></svg>;
const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const [currentPath, setCurrentPath] = useState('/');

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Handle scroll effect for navbar background
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, []);

  const navItems = [
    { href: '/', label: 'Schique' },
    { href: '/servicos', label: 'Serviços' },
    { href: '/sobre', label: 'Sobre Nós' },
    { href: '/contactos', label: 'Contactos' },
  ];

  const menuVariants = {
    closed: { opacity: 0, x: "-100%" },
    open: { opacity: 1, x: 0 },
  };

  const itemVariants = {
    closed: { opacity: 0, y: -10 },
    open: { opacity: 1, y: 0 }
  };


  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-shadow duration-500 ${isScrolled ? 'bg-white shadow-md' : 'lg:bg-transparent bg-white'}
      `}
    >
      <div className="container mx-auto flex justify-between items-center h-20 px-4">
        {/* Logo */}
        <a href="/" className="text-dark text-2xl md:text-3xl font-bold flex items-center">
          <img src="/logo.svg" alt="Schique Salon Logo" className="h-24" />
          {/* <span>Schique</span> */}
        </a>

        {/* Desktop Navigation */}
        <ul className="hidden lg:flex items-center space-x-8">
          {navItems.map((item) => (
            <motion.li key={item.label} whileHover={{ y: -2 }}>
              <div
                onClick={() => {
                  navigate(item.href);
                  setCurrentPath(item.href);
                }}
                className={`cursor-pointer ${currentPath === item.href ? 'text-textDark font-semibold scale-125' : 'text-textDark'} hover:text-primary transition duration-300 text-base font-medium`}
              >
                {item.label}
              </div>
            </motion.li>
          ))}
          <li>
            <Button onClick={() => window.open('https://buk.pt/schique', '_blank')} className="py-1 md:py-2 px-4 md:px-6 bg-zinc-400 text-white rounded-full hover:bg-zinc-500 hover:scale-105 transition-all duration-300 ease-in-out">
              Agendar horário
            </Button>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <div className="lg:hidden">
          <button onClick={toggleMenu} aria-label="Toggle menu">
            {isOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      {/* Mobile Menu (Animated) */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial="closed"
            animate="open"
            exit="closed"
            variants={menuVariants}
            transition={{ type: 'tween', duration: 0.3 }}
            className="lg:hidden absolute top-20 left-0 right-0 bg-white shadow-lg pb-6"
            style={{ transformOrigin: 'top' }} // Animation origin
          >
            <ul className="flex flex-col items-center space-y-4 pt-4">
              {navItems.map((item, index) => (
                <motion.li
                  key={item.label}
                  variants={itemVariants}
                  transition={{ delay: index * 0.05 }}
                >
                  <div
                    onClick={() => {
                      toggleMenu();
                      navigate(item.href);
                      setCurrentPath(item.href);
                    }}
                    className={`cursor-pointer block py-2 ${currentPath === item.href ? 'text-textDark font-semibold' : 'text-zinc-500'} hover:text-primary transition duration-300`}
                  >
                    {item.label}
                  </div>
                </motion.li>
              ))}
              <motion.li variants={itemVariants} transition={{ delay: navItems.length * 0.05 }}>
                <Button onClick={() => { window.open('https://buk.pt/schique', '_blank'); toggleMenu(); }} className="mt-4 bg-bordeux text-white border-2 border-transparent hover:bg-white hover:text-black hover:border-black active:bg-white active:text-black active:border-black transition-all duration-300">
                  Agendar horário
                </Button>
              </motion.li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar; 